export default __webpack_public_path__ + "static/char-54-49d07161f170455a23b9da653efb6334.webp";